/*
Usage - convert svelte app to web component
import component from "../libs/component.js"
new component({component:App,tagname:"hello-world",href="/your/stylesheet.css",attributes:["name"]})
*/

export default function(opts){
  class Wrapper extends HTMLElement{

    constructor() {
      super();
      let root = opts.shadow ? this.attachShadow({ mode: 'open' }) : this
      // link generated style
      if(opts.href && opts.shadow){
        let link = document.createElement('link');
        link.setAttribute("href",opts.href)
        link.setAttribute("rel","stylesheet")
        root.appendChild(link);
        // below stops webcomponents getting extra space in edit mode
        let style = document.createElement('style');
        style.appendChild(document.createTextNode("* {white-space: normal;-webkit-user-modify:read-only;}"));
        root.appendChild(style)
      }
      // get first attributes

      let props = opts.defaults ? opts.defaults : {};
      Array.from(this.attributes).forEach( attr => props[attr.name] = attr.value )

      this.elem = new opts.component({	target: root,	props});
      
      if(opts.shadow && root){
        // hack to swap v-slots for slots when using shadow dom !! Doesn't work if there are v-slots inside deep component, not sure how to resolve..
        Array.from(root.querySelectorAll('v-slot')).forEach((elem)=>{
          this.swapSlot(elem)
        })
        // watch for dom changes inside component, to swap v-slots to slots
        this.observer = new MutationObserver(this.processMutations.bind(this))
        this.observer.observe(root,{childList: true, subtree: true, attributes: false})
      }
    }
    static get observedAttributes() {
      return opts.attributes || []
    }

    // put slot inside v-slot to make it work
    swapSlot(elem){
      var dest = document.createElement('slot')
      if(elem.hasAttribute("name")){
        dest.setAttribute("name",elem.getAttribute("name"))
      }
      elem.innerHTML = ''
      elem.appendChild(dest)
    }

    processMutations(mutations){
      for(let mutation of mutations){
        if(mutation.type=="childList"){
          for(let node of mutation.addedNodes){
            if(node.nodeType==Node.ELEMENT_NODE && node.querySelector("v-slot")){
              this.swapSlot(node.querySelector("v-slot"))
            }
          }
        }
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if(this.elem && newValue!=oldValue){
        this.elem.$set({[name]:newValue})
      }
    }
  }  
  window.customElements.define(opts.tagname, Wrapper);
}